import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";

interface Shape {
  id: string;
}

const useStore = create<Shape>()(() => ({
  id: uuidv4(),
}));

/**
 * A stable userId for the customer.
 *
 * Currently this only keeps the id stable across a single page load. This is better than
 *
 * Future work:
 *  1. Store the userId in a cookie for pre-auth users to ensure consistency across loads
 *  2. Use a directed ID from profile service for signed in customers so we can tie to analytics
 *  3. Expose as an xb-hook. We are keeping this internal for now so we can be flexible in the evolution
 */
export const useUserId = () => {
  return useStore((state) => state.id);
};
